'use strict';

angular.module('membership')
  .controller('UserManagerDetailsSyncCtrl', [
    '$scope', 'manageUsersDetailsSyncViewModel', '$stateParams',
    function($scope, viewModel, $stateParams) {
      $scope.viewModel = new viewModel($stateParams.filter, $stateParams.action, $stateParams.userId);
    }
  ]);